var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.49984V5.5415C7 4.43693 7.89543 3.5415 9 3.5415H15C16.1046 3.5415 17 4.43693 17 5.5415V6.49984H19.3333C20.8061 6.49984 22 7.69374 22 9.1665V17.8332C22 19.3059 20.8104 20.4998 19.3376 20.4998H4.66707C3.19431 20.4998 2 19.3059 2 17.8332V9.1665C2 7.69374 3.19391 6.49984 4.66667 6.49984H7ZM15.5 6.49984V5.99984C15.5 5.44755 15.0523 4.99984 14.5 4.99984H9.5C8.94772 4.99984 8.5 5.44755 8.5 5.99984V6.49984H15.5ZM3.5 9.24984C3.5 8.51346 4.09695 7.9165 4.83333 7.9165H19.1667C19.903 7.9165 20.5 8.51346 20.5 9.24984V10.6288C20.0578 10.7633 19.4359 10.9364 18.666 11.1099C17.0148 11.4819 14.69 11.854 12 11.854C9.31002 11.854 6.98517 11.4819 5.33403 11.1099C4.56411 10.9364 3.94224 10.7633 3.5 10.6288V9.24984ZM18.959 12.4106C19.5621 12.2747 20.0803 12.1386 20.5 12.0188V17.6665C20.5 18.4029 19.903 18.9998 19.1667 18.9998H4.83333C4.09695 18.9998 3.5 18.4029 3.5 17.6665V12.0188C3.91975 12.1386 4.43788 12.2747 5.04097 12.4106C6.22884 12.6783 7.74969 12.9459 9.5 13.0864V13.4998C9.5 14.0521 9.94772 14.4998 10.5 14.4998H13.5C14.0523 14.4998 14.5 14.0521 14.5 13.4998V13.0864C16.2503 12.9459 17.7712 12.6783 18.959 12.4106Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.d8cc5da3.svg";
export { ForwardRef as ReactComponent };